var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginChairIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16",
    "data-name": "Group 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 361.695,
    height: 316.688,
    viewBox: "0 0 361.695 316.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 361.695,
    height: 316.688,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 10.23,
    height: 21.202,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 67.666,
    height: 2.414,
    transform: "translate(156.275 149.469)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 184.809,
    height: 9.197,
    transform: "translate(85.433 151.895)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 81.489,
    height: 9.197,
    transform: "translate(270.243 151.895)",
    fill: "#b6bab6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M125.817,636.432c.082-6.4-11.876-9.758-26.632-9.758-14.724,0-26.682,3.361-27.257,9.758Z",
    transform: "translate(-36.7 -319.743)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M127.345,455.063v86.673c0,1.519-12.829,1.519-12.829,0V455.063Z",
    transform: "translate(-58.429 -232.184)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M83.215,452.029c2.657,5.748,11.362,9.99,21.745,9.99,10.348,0,19.076-4.242,21.741-9.99Z",
    transform: "translate(-42.458 -230.636)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M246.248,481.532a3.1,3.1,0,0,1-3.092,2.757H229.823a3.114,3.114,0,0,1-3.1-2.876l-5.445-71.676A10.7,10.7,0,0,0,211,399.862l-49.136-1.753-4.195-13.766,12.22-16.493s66.6-8.37,75.693,13.135c6.249,14.791,1.744,84.212.67,100.547",
    transform: "translate(-80.444 -186.867)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M206.781,519.272a2.541,2.541,0,0,1-2.54,2.412H188.968a2.542,2.542,0,0,1-2.531-2.343l-5.79-72.3a10.625,10.625,0,0,0-4.225-7.681H208.14c1.16,21.639-.245,58.225-1.359,79.908",
    transform: "translate(-90.015 -224.174)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M368,290.216s-2.227,2.607-5.469-.382c0,0-1.526,3.814-4.577.382-4.387,2.924-11.763,2.161-16.913,1.144l-.637.127-2.988-.955v-.064c-1.4-.381-2.226-.635-2.226-.635l1.78-3.433s.191-.064.446-.127v-6.231l-2.226-.573s31.156-5.849,35.861,9.537c.382,1.271.064,3.307-3.051,1.209",
    transform: "translate(-171.021 -142.035)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M183.192,229.6s-38.156,2.727-58.63-7c-5.426-2.581-11.382-8.1-16.781-14.347.693,14.7,2.567,25.876,1.376,51.589C107.793,288.691,79.7,284.985,79.7,284.985s-47.579-49.564-45.951-92.869c.556-14.744,4.262-24.127,9.105-30.043,10.733-13.116,27.065-9.265,27.065-9.265,19.1,2.541,28.958,7.121,33.895,13.116h.013l.026.053a292.6,292.6,0,0,0,26.682,32.716c15.776,16.6,52.661,14.32,52.661,14.32,2.422,0,2.422,16.583,0,16.583",
    transform: "translate(-17.196 -77.698)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M131.311,335.585c.45,3.2-2.077,5.166-5.222,5.335-21.977,1.066-71.117,2.322-95.562-.562-31.5-3.482-28.635-37.674-28.635-37.674-.031-1.132-2.974-48.969-1.46-58.057,1.74-9.994,9.489-10.78,9.489-10.78,45.872-3.93,50.589,25.94,50.589,25.94.958,2.8,12.855,49.125,21.5,61.761A19.685,19.685,0,0,0,98.69,330.7h25.154s6.57-.45,7.355,4.717c0,.055,0,.111.113.168",
    transform: "translate(0 -119.132)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M307.75,607.266l-.194,9.129c2.865,6.393,6.31,7.413,10.541,1.125l.217-10.255Z",
    transform: "translate(-156.922 -309.841)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M312.834,619.4h0a1.673,1.673,0,0,1,1.684-1.663h0a1.672,1.672,0,0,1,1.567,1.115,7.51,7.51,0,0,0,4.659,4.6l7.618,2.593a3.646,3.646,0,0,1,2.471,3.475.453.453,0,0,1-.456.45l-30.855-.2a.453.453,0,0,1-.45-.456l.026-4.188s.14-5.27,4.442-6.259c0,0,2.087,4.427,6.316,4.034,2.636-.245,2.973-3.508,2.973-3.508",
    transform: "translate(-152.596 -315.182)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M302.654,629.957a3.172,3.172,0,0,1-.243,2.491l-3.3-.021.016-2.186a8.748,8.748,0,0,1,.512-2.494,3.174,3.174,0,0,1,3.017,2.21",
    transform: "translate(-152.613 -320.291)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M206.7,607.442l-.187,8.789c2.865,6.393,6.309,7.413,10.541,1.125l.21-9.914Z",
    transform: "translate(-105.366 -309.931)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M211.788,618.878h0a1.674,1.674,0,0,1,1.684-1.663h0a1.672,1.672,0,0,1,1.567,1.115,7.51,7.51,0,0,0,4.659,4.6l7.618,2.593A3.646,3.646,0,0,1,229.792,629a.453.453,0,0,1-.455.45l-30.855-.2a.452.452,0,0,1-.45-.455l.026-4.188s.14-5.27,4.442-6.259c0,0,2.087,4.427,6.316,4.034,2.636-.245,2.973-3.508,2.973-3.508",
    transform: "translate(-101.04 -314.917)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M201.608,629.439a3.169,3.169,0,0,1-.243,2.491l-3.3-.022.016-2.186a8.768,8.768,0,0,1,.512-2.493,3.175,3.175,0,0,1,3.018,2.21",
    transform: "translate(-101.056 -320.027)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M131.048,92.206c-.064,1.4-1.209,1.208-2.289.7.127,5.533-.637,10.11-3.18,10.3a39.966,39.966,0,0,1-8.647-.127l-1.145,9.474s-18.884-1.144-18.439-2.606,2.035-13.735.571-25.688c-1.462-12.018,17.868-20.664,27.087-10.936,1.082,1.207,2.481,6.613,3.243,12.462.509.635,2.925,4.006,2.8,6.422",
    transform: "translate(-49.666 -35.268)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M125.728,68.538c.75-23.041-32.165-6.585-32.165-6.585C76.112,52.905,83.506,88.772,87.21,93.076c1.657,1.926,9.447,3.155,14.324,1.716a3.291,3.291,0,0,0,2.365-3.214c-.074-4.149-1.952-12.724,2.78-13.118,2.338-.195,2.661,5.447,2.643,7.023h1.294l-.212-5.575c4.745-.939,2.1-4.586,2.1-4.586s13.035-1.013,13.223-6.784",
    transform: "translate(-42.067 -28.705)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M132.65,137.161h-.025a11.091,11.091,0,0,1-4.352-1.311.279.279,0,0,1-.116-.381.271.271,0,0,1,.381-.116,10.573,10.573,0,0,0,4.137,1.245.282.282,0,0,1-.025.563",
    transform: "translate(-65.372 -69.041)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M157.391,122.35h-.03a8.949,8.949,0,0,1-3.282-1.04.28.28,0,0,1-.116-.381.275.275,0,0,1,.381-.116,8.439,8.439,0,0,0,3.077.974.282.282,0,0,1-.03.563",
    transform: "translate(-78.538 -61.623)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M128.713,109.285a2.865,2.865,0,0,1-.215-3.742.283.283,0,0,1,.386.414,2.331,2.331,0,0,0,.251,2.953.257.257,0,0,1,.182.334c-.064.238-.388.275-.6.041",
    transform: "translate(-65.259 -53.812)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M154.108,101.029a.684.684,0,0,1-.433.879.693.693,0,0,1-.879-.433.7.7,0,0,1,.433-.879.693.693,0,0,1,.879.433",
    transform: "translate(-77.943 -51.307)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M148.91,98.822a.276.276,0,0,1-.229-.116.283.283,0,0,1,.063-.395,6.568,6.568,0,0,1,2.544-1.112.268.268,0,0,1,.331.221.278.278,0,0,1-.221.331,6.026,6.026,0,0,0-2.324,1.018.282.282,0,0,1-.166.052",
    transform: "translate(-75.833 -49.586)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M116.131,150.789c.888.659.675,4.459.675,4.459l-24.543-3.08s-1-3.81,1.342-4.889c1.734-.8,19.82,1.5,22.525,3.51",
    transform: "translate(-46.966 -75.062)",
    fill: "#b6bab6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(81.015 119.804)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M175.643,265.813l-10.23-21.2,9.568,10.748Z",
    transform: "translate(-165.413 -244.61)",
    fill: "#b6bab6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M376.721,298.175h0c.011-.1.221-2.5-3.979-3.579a.282.282,0,0,1-.2-.342.293.293,0,0,1,.345-.2c4.7,1.209,4.413,4.071,4.4,4.192a.284.284,0,0,1-.563-.066",
    transform: "translate(-190.074 -150.028)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M388.287,298.1a.281.281,0,0,1-.282-.27,4.3,4.3,0,0,0-2.194-3.273.283.283,0,1,1,.292-.485,4.843,4.843,0,0,1,2.465,3.737.281.281,0,0,1-.271.292Z",
    transform: "translate(-196.78 -150.023)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M398.681,298.887a.281.281,0,0,1-.279-.232,4.868,4.868,0,0,0-2.909-3.287.287.287,0,0,1-.143-.375.281.281,0,0,1,.375-.144,5.435,5.435,0,0,1,3.234,3.706.286.286,0,0,1-.229.329.333.333,0,0,1-.049,0",
    transform: "translate(-201.704 -150.426)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M495.267,300.146a3.611,3.611,0,0,0,3.613,3.613H548.9l4.786-7.225H498.88a3.611,3.611,0,0,0-3.613,3.613",
    transform: "translate(-252.697 -151.298)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M599.712,264.68a3.623,3.623,0,0,1-3.62,3.62H572.808a3.628,3.628,0,0,1-3.605-3.993,3.78,3.78,0,0,1,3.806-3.247h18.386l-7.628-29.534a3.616,3.616,0,0,1,7.01-1.781c9.83,38.052,8.935,34.316,8.935,34.935",
    transform: "translate(-290.411 -115.831)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M525.564,240.825l7.11,27.279h36.47l-7.116-27.279Z",
    transform: "translate(-268.155 -122.874)",
    fill: "#b6bab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M694.766,128.691h6.918a7.22,7.22,0,0,0,7.2-6.679l7.278-96.76a7.217,7.217,0,0,0-7.2-7.765h-6.918a7.216,7.216,0,0,1,7.2,7.765l-7.277,96.76a7.22,7.22,0,0,1-7.2,6.679",
    transform: "translate(-354.486 -8.922)",
    fill: "#43a848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M694.766,128.691h4.35a7.22,7.22,0,0,0,7.2-6.679l7.278-96.76a7.217,7.217,0,0,0-7.2-7.765h-4.35a7.216,7.216,0,0,1,7.2,7.765l-7.277,96.76a7.22,7.22,0,0,1-7.2,6.679",
    transform: "translate(-354.486 -8.922)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M406.625,128.69H544.06a7.22,7.22,0,0,0,7.2-6.679l.266-3.565c.71-9.43-2.586,34.353,7.014-93.194a7.217,7.217,0,0,0-7.2-7.765H413.9a7.22,7.22,0,0,0-7.2,6.679c-7.769,103.126-7.056,93.658-7.1,94.28l-.185,2.479a7.226,7.226,0,0,0,7.205,7.765",
    transform: "translate(-203.783 -8.922)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M411.926,128.9a2.14,2.14,0,0,1-2.133-2.3l7.285-96.761a2.146,2.146,0,0,1,2.128-1.973H556.639a2.131,2.131,0,0,1,2.128,2.293l-7.28,96.767a2.146,2.146,0,0,1-2.128,1.973Z",
    transform: "translate(-209.083 -14.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M406.625,233.864H544.06a7.22,7.22,0,0,0,7.2-6.679l.266-3.565H399.6l-.185,2.479a7.226,7.226,0,0,0,7.205,7.765",
    transform: "translate(-203.783 -114.096)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M553.811,230.654a2.885,2.885,0,0,1-2.827,2.634,2.4,2.4,0,0,1-2.372-2.634,2.873,2.873,0,0,1,2.761-2.632,2.413,2.413,0,0,1,2.437,2.632",
    transform: "translate(-279.911 -116.342)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M225.439,2.6l-.215,42.772a2.579,2.579,0,0,0,2.587,2.6h9.079l-.063,12.547a1.434,1.434,0,0,0,2.354,1.12l16.775-13.667h38.134a2.61,2.61,0,0,0,2.613-2.6L296.921,2.6A2.579,2.579,0,0,0,294.333,0H228.052a2.61,2.61,0,0,0-2.613,2.6",
    transform: "translate(-114.915 0)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M231.862,8.424,231.673,46.1a1.984,1.984,0,0,0,1.989,2h61.185a2.028,2.028,0,0,0,1.873-1.238,2.078,2.078,0,0,0,.146-.761l.189-37.678a1.993,1.993,0,0,0-2-2H233.871a2.008,2.008,0,0,0-2.009,2",
    transform: "translate(-118.205 -3.278)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M291.518,36.323a6.169,6.169,0,0,0-2.753.648,6.092,6.092,0,0,0-1.937,1.345c-4.394,4.535-7.7,4.542-12.551-.153a6.058,6.058,0,0,0-2.23-1.374,6.194,6.194,0,1,0-.683,11.693,5.8,5.8,0,0,0,3.054-1.717c4.99-5.052,8.325-3.936,12.551.153a6.062,6.062,0,0,0,2.791,1.538,6.193,6.193,0,1,0,1.757-12.133",
    transform: "translate(-134.443 -18.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M486.063,140.62H433.376a.568.568,0,0,1-.419-.188.56.56,0,0,1-.144-.436l.927-9.206a.568.568,0,0,1,.563-.508h52.69a.569.569,0,0,1,.563.624l-.93,9.206a.568.568,0,0,1-.563.507M434,139.488h51.553l.814-8.074H434.814Z",
    transform: "translate(-220.829 -66.473)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M481.955,184.569H429.268a.568.568,0,0,1-.419-.188.56.56,0,0,1-.143-.436l.927-9.206a.568.568,0,0,1,.563-.508h52.69a.569.569,0,0,1,.563.624l-.93,9.206a.568.568,0,0,1-.563.507m-52.063-1.131h51.553l.814-8.074H430.706Z",
    transform: "translate(-218.733 -88.897)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M464.1,205.62h-36.01a.566.566,0,1,1,0-1.131H464.1a.566.566,0,1,1,0,1.131",
    transform: "translate(-218.134 -104.335)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M440.766,138.985a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-224.886 -70.004)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M454.42,138.985a1.617,1.617,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.643-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-231.852 -70.004)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M468.073,138.985a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.914,1.782",
    transform: "translate(-238.819 -70.004)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M481.726,138.985a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-245.785 -70.004)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M495.379,138.985a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-252.751 -70.004)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M436.574,183.556a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-222.747 -92.745)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M450.227,183.556a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-229.713 -92.745)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M463.88,183.556a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-236.679 -92.745)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M477.534,183.556a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.915,1.782",
    transform: "translate(-243.646 -92.745)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M491.187,183.556a1.618,1.618,0,0,0,1.637,1.776,1.953,1.953,0,0,0,1.921-1.776,1.625,1.625,0,0,0-1.644-1.782,1.957,1.957,0,0,0-1.914,1.782",
    transform: "translate(-250.612 -92.745)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M469.069,163.987H433.061a.566.566,0,0,1,0-1.131h36.008a.566.566,0,1,1,0,1.131",
    transform: "translate(-220.669 -83.093)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M461.607,59.675A15.617,15.617,0,0,0,477.368,76.4a17.94,17.94,0,0,0,17.684-16.725A15.613,15.613,0,0,0,479.294,42.95a17.944,17.944,0,0,0-17.688,16.725",
    transform: "translate(-235.508 -21.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M476.78,76.374a16.168,16.168,0,0,1-16.323-17.322,18.535,18.535,0,0,1,18.25-17.259,16.168,16.168,0,0,1,16.32,17.325A18.528,18.528,0,0,1,476.78,76.374m1.926-33.45a17.393,17.393,0,0,0-17.124,16.194,15.042,15.042,0,0,0,15.2,16.125A17.388,17.388,0,0,0,493.9,59.052a15.042,15.042,0,0,0-15.195-16.127",
    transform: "translate(-234.92 -21.324)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M477.528,85.909a.945.945,0,0,1-.92-1.179,9.858,9.858,0,0,1,9.481-7.65,8.536,8.536,0,0,1,8.6,7.651,1.076,1.076,0,0,1-1.056,1.179Z",
    transform: "translate(-243.163 -39.327)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M487.5,59.328a4.21,4.21,0,0,0,4.25,4.509,4.837,4.837,0,0,0,4.768-4.509,4.209,4.209,0,0,0-4.249-4.509,4.838,4.838,0,0,0-4.769,4.509",
    transform: "translate(-248.727 -27.97)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M581,70.471h-3.038a.566.566,0,1,1,0-1.131H581a.566.566,0,1,1,0,1.131",
    transform: "translate(-294.601 -35.379)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M579.248,88.817H576.21a.566.566,0,1,1,0-1.131h3.038a.566.566,0,1,1,0,1.131",
    transform: "translate(-293.707 -44.739)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M577.5,107.163h-3.038a.566.566,0,1,1,0-1.131H577.5a.566.566,0,1,1,0,1.131",
    transform: "translate(-292.816 -54.1)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M575.749,125.509h-3.038a.566.566,0,1,1,0-1.131h3.038a.566.566,0,0,1,0,1.131",
    transform: "translate(-291.921 -63.461)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M660.848,70.471h-26.5a.566.566,0,1,1,0-1.131h26.5a.566.566,0,0,1,0,1.131",
    transform: "translate(-323.373 -35.379)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M608.243,70.471H598.022a.566.566,0,1,1,0-1.131h10.222a.566.566,0,0,1,0,1.131",
    transform: "translate(-304.836 -35.379)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M679,88.817h-8.5a.566.566,0,0,1,0-1.131H679a.566.566,0,0,1,0,1.131",
    transform: "translate(-341.815 -44.739)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M625.7,88.817H596.275a.566.566,0,1,1,0-1.131H625.7a.566.566,0,0,1,0,1.131",
    transform: "translate(-303.944 -44.739)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M671.338,107.163H657.173a.566.566,0,0,1,0-1.131h14.165a.566.566,0,0,1,0,1.131",
    transform: "translate(-335.016 -54.1)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M620.794,107.163H594.522a.566.566,0,1,1,0-1.131h26.272a.566.566,0,1,1,0,1.131",
    transform: "translate(-303.05 -54.1)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M657.861,125.509H632.415a.566.566,0,1,1,0-1.131h25.446a.566.566,0,1,1,0,1.131",
    transform: "translate(-322.384 -63.461)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M607,125.509H592.771a.566.566,0,0,1,0-1.131H607a.566.566,0,0,1,0,1.131",
    transform: "translate(-302.156 -63.461)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M574.161,143.849h-3.038a.566.566,0,1,1,0-1.131h3.038a.566.566,0,0,1,0,1.131",
    transform: "translate(-291.111 -72.818)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M670.8,143.849H659.3a.566.566,0,0,1,0-1.131h11.5a.566.566,0,1,1,0,1.131",
    transform: "translate(-336.1 -72.818)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M618.78,143.849h-27.6a.566.566,0,1,1,0-1.131h27.6a.566.566,0,1,1,0,1.131",
    transform: "translate(-301.345 -72.818)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M572.572,162.2h-3.039a.566.566,0,0,1,0-1.131h3.039a.566.566,0,0,1,0,1.131",
    transform: "translate(-290.301 -82.179)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M647.9,162.2H615.934a.566.566,0,1,1,0-1.131H647.9a.566.566,0,0,1,0,1.131",
    transform: "translate(-313.975 -82.179)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M596.726,162.2h-7.134a.566.566,0,1,1,0-1.131h7.134a.566.566,0,0,1,0,1.131",
    transform: "translate(-300.535 -82.179)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M570.982,180.541h-3.038a.566.566,0,1,1,0-1.131h3.038a.566.566,0,1,1,0,1.131",
    transform: "translate(-289.489 -91.539)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M606.767,180.541H588a.566.566,0,1,1,0-1.131h18.763a.566.566,0,0,1,0,1.131",
    transform: "translate(-299.724 -91.539)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M569.394,198.881h-3.039a.566.566,0,0,1,0-1.131h3.039a.566.566,0,1,1,0,1.131",
    transform: "translate(-288.679 -100.897)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M631.281,198.881H586.421a.566.566,0,1,1,0-1.131h44.861a.566.566,0,1,1,0,1.131",
    transform: "translate(-298.917 -100.897)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M656.159,180.541H640.308a.566.566,0,0,1,0-1.131h15.852a.566.566,0,1,1,0,1.131",
    transform: "translate(-326.411 -91.539)",
    fill: "#dbdfdb"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Login",
    transform: "translate(283.167 25.332)",
    fill: "#70b971",
    fontSize: 6,
    fontFamily: "Ubuntu-MediumItalic, Ubuntu",
    fontWeight: 500,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-0.046em"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ogin")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginChairIcon);
export default __webpack_public_path__ + "static/media/login_chair_icon.123596dc0ffc547b981b24c7026a3402.svg";
export { ForwardRef as ReactComponent };